'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
const img = require('./card-debit.png');
const img$1 = require('./card-debit@2x.png');
const img$2 = require('./card-debit@3x.png');
const img$3 = require('./card-visa-classic.png');
const img$4 = require('./card-visa-classic@2x.png');
const img$5 = require('./card-visa-classic@3x.png');
const img$6 = require('./card-visa-gold.png');
const img$7 = require('./card-visa-gold@2x.png');
const img$8 = require('./card-visa-gold@3x.png');
const img$9 = require('./card-visa-platinum.png');
const img$10 = require('./card-visa-platinum@2x.png');
const img$11 = require('./card-visa-platinum@3x.png');
const img$12 = require('./card-visa-debit.png');
const img$13 = require('./card-visa-debit@2x.png');
const img$14 = require('./card-visa-debit@3x.png');
var CARDS = {
  cardDebit: img,
  cardDebit2x: img$1,
  cardDebit3x: img$2,
  cardVisaClassic: img$3,
  cardVisaClassic2x: img$4,
  cardVisaClassic3x: img$5,
  cardVisaGold: img$6,
  cardVisaGold2x: img$7,
  cardVisaGold3x: img$8,
  cardVisaPlatinum: img$9,
  cardVisaPlatinum2x: img$10,
  cardVisaPlatinum3x: img$11,
  cardVisaDebit: img$12,
  cardVisaDebit2x: img$13,
  cardVisaDebit3x: img$14
};
var CARDS_VALUES = {
  cardDebit: img,
  cardVisaClassic: img$3,
  cardVisaGold: img$6,
  cardVisaPlatinum: img$9,
  cardVisaDebit: img$12
};
var getWidth = function getWidth(imgWidth, imgHeight) {
  if (imgWidth) return imgWidth;
  if (imgHeight) return 'auto';
  return '34.7rem';
}; // Workaround to make this package consummable by projects that don't allow CommonJS imports. Ideally we would only export in ES6 but not sure what this would break.

var getImageSource = function getImageSource(file) {
  return file.default || file;
};
var StyledImage = styled.img.withConfig({
  displayName: "CardImage__StyledImage",
  componentId: "sc-13b1giq-0"
})(["margin:", ";height:", ";width:", ";max-width:34.7rem;"], function (props) {
  return props.margin;
}, function (props) {
  return props.imgWidth && props.imgHeight ? 'auto' : props.imgHeight;
}, function (props) {
  return getWidth(props.imgWidth, props.imgHeight);
});
var CardImage = function CardImage(_ref) {
  var type = _ref.type,
    imgHeight = _ref.imgHeight,
    imgWidth = _ref.imgWidth,
    margin = _ref.margin;
  return /*#__PURE__*/React.createElement(StyledImage, {
    imgHeight: imgHeight,
    imgWidth: imgWidth,
    margin: margin,
    src: getImageSource(CARDS_VALUES[type]),
    srcSet: "\n        ".concat(getImageSource(CARDS["".concat(type, "2x")]), " 2x,\n        ").concat(getImageSource(CARDS["".concat(type, "3x")]), " 3x\n    ")
  });
};
exports.CardImage = CardImage;